// @ts-nocheck
import {Column} from 'react-table'

import {User} from '../../core/_models'
import {FormattedMessage} from 'react-intl'
// import {CustomerActionsCell} from '../../../../../_template/layout/components/columns/CustomerActionsCell'
// import {DateCell} from '../../../../../../_template/layout/components/columns/DateAnTimeCell'
// import { CustomerActionsCell } from '../../../../../../../_template/layout/components/columns/CustomerActionsCell'
import {UserCustomHeader} from '../../../../../../../_template/layout/components/columns'
import {DateCell} from '../../../../../../../_template/layout/components/columns/DateAnTimeCell'
import {FirstCell} from '../../../../../../../_template/layout/components/columns/FirstCell'

const customerColumns: ReadonlyArray<Column<User>> = [


  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='GORELLA.COMMON.TITLE' />}
        className='min-w-125px'
      />
    ),

    id: 'title',
    Cell: ({...props}) => <FirstCell value={props.data[props.row.index].title} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='GORELLA.COMMON.MESSAGE' />}
        className='min-w-125px'
      />
    ),
    accessor: 'message',
  },
  
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title={<FormattedMessage id='GORELLA.COMMON.CREATIONDATE' />}
        className='min-w-80px'
      />
    ),

    id: 'createDate',
    Cell: ({...props}) => <DateCell date={props.data[props.row.index].createDate} />,
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader
  //       tableProps={props}
  //       title={<FormattedMessage id='MENU.ACTIONS' />}
  //       className='text-end min-w-100px'
  //     />
  //   ),
  //   id: 'actions',
  //   Cell: ({...props}) => <DeliveryTypeActionsCell id={props.data[props.row.index]._id} />,
  // },
]

export default customerColumns
